import { render, staticRenderFns } from "./WhatsAppProfile.settings.vue?vue&type=template&id=14156a6b&scoped=true&"
import script from "./WhatsAppProfile.settings.vue?vue&type=script&lang=js&"
export * from "./WhatsAppProfile.settings.vue?vue&type=script&lang=js&"
import style0 from "./WhatsAppProfile.settings.vue?vue&type=style&index=0&id=14156a6b&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14156a6b",
  null
  
)

export default component.exports